import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import options from './modules/options'
import works from './modules/works'
import talent from './modules/talent'
import mergedNews from './modules/merged_news'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  success: 0,
  error: null,
  loader: false
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    options,
    works,
    talent,
    mergedNews
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js